var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodriverCockpitAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / codriver_cockpit_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-31.7033874%",
    x2: "50%",
    y2: "132.320256%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-12.244898%",
    y1: "-12.244898%",
    x2: "110.204082%",
    y2: "110.204082%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.0280294%",
    y1: "105.205312%",
    x2: "40.9832989%",
    y2: "-19.0422537%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948F8F",
    stopOpacity: 0.867132867,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.8470607%",
    y1: "12.7220465%",
    x2: "88.7131077%",
    y2: "115.88871%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2251A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E0F0A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.1393581%",
    y1: "-11.4125845%",
    x2: "90.464527%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B33229",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B33229",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-codriver_cockpit_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CockpitApp",
    transform: "translate(0.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5030866,7.99951298 L21,8 L20.6769603,8.00300785 C11.4371956,8.17520404 4,15.719077 4,25 C4,34.280923 11.4371956,41.824796 20.6769603,41.9969921 L21,42 L21.5030866,42.000487 C22.5457059,43.4390221 23.7171956,44.7780602 25.0006131,46.0006583 L21,46 C9.40202025,46 0,36.5979797 0,25 C0,13.5191716 9.21303974,4.19016386 20.6492257,4.00287045 L21,4 L25.0016145,3.99838785 C23.717805,5.22124334 22.545977,6.56060374 21.5030866,7.99951298 Z M69,4 C80.5979797,4 90,13.4020203 90,25 C90,36.4808284 80.7869603,45.8098361 69.3507743,45.9971296 L69,46 L64.9993869,46.0006583 C66.2828044,44.7780602 67.4542941,43.4390221 68.4969134,42.000487 L69,42 L69.3230397,41.9969921 C78.5628044,41.824796 86,34.280923 86,25 C86,15.6111593 78.3888407,8 69,8 L68.4969134,7.99951298 C67.454023,6.56060374 66.282195,5.22124334 64.9983855,3.99838785 L69,4 Z",
    id: "AreaC-D---Fill",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Instrument",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Area-C---Fill",
    fill: "#000000",
    cx: 25,
    cy: 25,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Area-C---Border",
    stroke: "url(#linearGradient-2)",
    strokeWidth: 4,
    cx: 25,
    cy: 25,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59836393,18.5 L12.8270152,21.7517351 C12.5445597,22.7899647 12.3734371,23.8759529 12.3734371,25.0034702 C12.3734371,28.2359065 13.6025352,31.1850821 15.6138258,33.4026273 L16,33.8097338 L13.0806065,36.75 C10.0952381,33.7432871 8.25,29.5903686 8.25,25.0034702 C8.25,22.9454685 8.64096292,20.9875469 9.32732006,19.1734564 L9.59836393,18.5 Z",
    id: "Path---Fill",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,13 L17,14 L24,21 L23.8255703,21.1751844 C24.1969377,21.0612917 24.5913111,21 25,21 C27.209139,21 29,22.790861 29,25 C29,27.209139 27.209139,29 25,29 C22.790861,29 21,27.209139 21,25 C21,24.5913111 21.0612917,24.1969377 21.1751844,23.8255703 L21,24 L14,17 L13,13 Z",
    id: "Pointer---Fill",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6871843,13.6871843 L16.7443752,14.451482 L23.7107566,21.4178634 C24.0144992,21.528168 24.2798276,21.5314333 24.5921347,21.5149336 C25.9392832,21.5037394 26.8324948,21.8827474 27.4748737,22.5251263 C28.1082492,23.1585017 28.5,24.0335017 28.5,25 C28.5,25.9664983 28.1082492,26.8414983 27.4748737,27.4748737 C26.8414983,28.1082492 25.9664983,28.5 25,28.5 C24.0335017,28.5 23.1585017,28.1082492 22.5251263,27.4748737 C21.8917508,26.8414983 21.5,25.9664983 21.5,25 C21.5,24.5355625 21.5902683,24.0922135 21.7546208,23.6866786 L21.7546208,23.6866786 L14.4498464,16.7378326 L13.6871843,13.6871843 Z",
    id: "Pointer---Border",
    stroke: "url(#linearGradient-5)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodriverCockpitAppTile);
export default __webpack_public_path__ + "static/media/codriver_cockpit_app_tile.f6666f0503137816a64c536f5df0a511.svg";
export { ForwardRef as ReactComponent };